import { IconButton, IconButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { AppAdaptedTooltip } from '@frontend-libs/portal';

import { tApp } from '@frontend/locales';

import { BackIcon } from '../icons';

export interface AppHeaderBackActionProps {
  delta?: number;
  to?: string;
  replace?: boolean;
  bg?: string;
  size?: IconButtonProps['size'];
}

export const AppHeaderBackAction = (props: AppHeaderBackActionProps) => {
  const navigate = useNavigate();

  return (
    <AppAdaptedTooltip title={tApp.actions.goBack()}>
      <IconButton
        data-testid="app-header-back-action"
        sx={{
          backgroundColor: props.bg,
          '&:hover': {
            backgroundColor: props.bg,
          },
        }}
        onClick={() =>
          props.to
            ? navigate(props.to, { replace: props.replace })
            : navigate(props.delta ?? -1)
        }
        size={props.size ?? 'small'}
      >
        <BackIcon />
      </IconButton>
    </AppAdaptedTooltip>
  );
};
